import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailerDetentionReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomerId: ExcludableTextbox;
    excludabletextboxLocationId: ExcludableTextbox;
    spacer: Label;
    textboxDailyRateA: Textbox;
    textboxDailyRateB: Textbox;
    textboxDailyRateC: Textbox;
    textboxDailyRateD: Textbox;
    textboxDailyRateE: Textbox;
    textboxDaysA: Textbox;
    textboxDaysB: Textbox;
    textboxDaysC: Textbox;
    textboxDaysD: Textbox;
    textboxDaysDropped: Textbox;
    textboxDaysE: Textbox;
    textboxDroppedDates: Textbox;
    textboxFreeDaysAllowed: Textbox;
    textboxGroupBy: Textbox;
    textboxThroughA: Textbox;
    textboxThroughB: Textbox;
    textboxThroughC: Textbox;
    textboxThroughD: Textbox;
    textboxThroughE: Textbox;
    trailerDetentionReportDatasource: DataSource;
}
